import Muuri from 'muuri';

const handler = ($) => {

	const $resourcesMasonryGrid = $('.block-explore-resources .all-categories-grid .items');

	if( $resourcesMasonryGrid.length ) {

		$resourcesMasonryGrid.each( function() {
			new Muuri( $(this)[0] );
		});

	}

};

export default (($) => $(handler))(jQuery);
